import { AnimationEvent } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy } from '@angular/core';
import { IFilterResponse } from '@impact/data';
import { IMPACT_OVERLAY_DATA, ImpactOverlayRef } from '@impactdk/ngx-overlay';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FilterService } from '../../filter-service/filter.service';
import { COLLAPSE_PANELS, IPageFacets, MobileFacetListData } from '../../models/filter.models';
import { mobileAnimation, MobileAnimationState } from '../../utils/animations/mobile-menu.animations';

@Component({
    selector: 'app-mobile-facet-list',
    template: `
        <aside [@slideContent]="animationState" (@slideContent.done)="onAnimationDone($event)" class="mobile-facet-list-wrapper">
            <app-mobile-overlay-header (closed)="closeOverlay()"></app-mobile-overlay-header>
            <div class="mobile-facet-list">
                <div class="mobile-facet-list__content">
                    <h1 class="mobile-facet-list__header">{{ 'filterpage.filter' | translate }}</h1>
                    <app-active-facets></app-active-facets>
                    <app-facet-list [onMobile]="true" class="mobile-facet-list__list" [facets]="facets"></app-facet-list>
                </div>
            </div>
            <div class="mobile-facet-list__footer">
                <app-button buttonClass="button--quaternary" (click)="resetFacets()">
                    {{ 'filterpage.filter_reset_button_text' | translate }}
                </app-button>
                <app-button buttonClass="button--primary" [loading]="!!(filterService.isLoading$ | async)" (click)="closeOverlay()">
                    {{ 'filterpage.facets____show_results' | translate: { value: (facetData$ | async)?.total } }}
                </app-button>
            </div>
        </aside>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [mobileAnimation],
    providers: [
        {
            provide: COLLAPSE_PANELS,
            useValue: false,
        },
    ],
})
export class MobileFacetListComponent implements OnDestroy {
    @Input() facets: IPageFacets;

    animationState: MobileAnimationState = 'enter';

    facetData$: Observable<IFilterResponse | null>;

    private readonly unsubscribe = new Subject<void>();

    constructor(
        @Inject(IMPACT_OVERLAY_DATA) data: MobileFacetListData,
        cdr: ChangeDetectorRef,
        private overlayRef: ImpactOverlayRef,
        public filterService: FilterService
    ) {
        data.facets.pipe(takeUntil(this.unsubscribe)).subscribe((facets) => {
            this.facets = facets;
            cdr.markForCheck();
        });

        this.facetData$ = this.filterService.filterData;
    }
    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    closeOverlay() {
        this.animationState = 'leave';
    }

    onAnimationDone(event: AnimationEvent) {
        if (event.toState === 'leave') {
            this.overlayRef.close();
        }
    }

    resetFacets() {
        this.filterService.resetFacets();
    }
}
